export default {
  main: '#EFE7DD',
  secondary: '#445E5A',
  contrastingColor: '#000000',
  priceColor: '#445E5A',
  entryBackground: '#EFE7DD',
  menuBackgroundColor: '#fad2dc',
  menuTextColor: '#000000',
};
